import { convertToExportedView } from '@estee/elc-service';
import { CART_SIDEBAR_OFFERS_TAB } from '@estee/elc-service-view-names';
import { serviceNames } from '~setup/OffersService';
import ICartSidebarOffersTab from './ICartSidebarOffersTab';

export type INTERFACE = ICartSidebarOffersTab;

// @ts-ignore
export default convertToExportedView<ICartSidebarOffersTab>(
    () => import('./CartSidebarOffersTab'),
    CART_SIDEBAR_OFFERS_TAB,
    serviceNames.offersViewController
);
